<template>
    <section>
        <div class="accordion-bar">
            <div class="accordion">
                <div class="icon-title" @click="activeAcordion">
                    <div class="icon">
                        <i v-if="active" class="fal fa-folder-open"/>
                        <i v-else class="fal fa-folder"/>
                    </div>
                    <div class="options">
                        <slot name="action"/>
                    </div>
                </div>
                <div v-if="setButton" class="options">
                    <slot name="button"/>
                </div>
            </div>
            <div class="accordion-content" :class="{'active-accordion': active}">
                <div class="content-accordion">
                    <div v-if="loading" class="loading-accordion">
                        <ui-load-indicator :h="50" :stroke="8" bg-color="#DFE5EC" color="#69D296" />
                    </div>

                    <slot v-else name="content"/>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
import { uiLoadIndicator } from '@/components/ui'

export default {
	name: 'accordion-multiple',
	components: {
		uiLoadIndicator
	},
	props: {
		active: {
			type: Boolean,
			required: true,
			default: false
		},
		setButton: {
			type: Boolean,
			default: false
		},
		set: {
			type: [String, Number],
			required: true
		},
		title: {
			type: String,
			required: true
		},
		loading: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		activeAcordion() {
			this.$emit('input', this.set)
		}
	}

}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>